/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { HealthMetricsResponse } from './health-metrics-response';
// May contain unused imports in some cases
// @ts-ignore
import { MembershipResponse } from './membership-response';
// May contain unused imports in some cases
// @ts-ignore
import { SubscriptionDetailResponse } from './subscription-detail-response';

/**
 * 
 * @export
 * @interface UserDetailResponse
 */
export interface UserDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'gender'?: UserDetailResponseGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'birthDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDetailResponse
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDetailResponse
     */
    'weight'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDetailResponse
     */
    'targetWeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'dietGoal'?: UserDetailResponseDietGoalEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'activityLevel'?: UserDetailResponseActivityLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'dietType'?: UserDetailResponseDietTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserDetailResponse
     */
    'walletActualBalance'?: number;
    /**
     * 
     * @type {HealthMetricsResponse}
     * @memberof UserDetailResponse
     */
    'healthMetrics'?: HealthMetricsResponse;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailResponse
     */
    'allergens'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailResponse
     */
    'medicalConditions'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailResponse
     */
    'dislikes'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailResponse
     */
    'roles'?: Set<string>;
    /**
     * 
     * @type {SubscriptionDetailResponse}
     * @memberof UserDetailResponse
     */
    'activeSubscription'?: SubscriptionDetailResponse;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'deliveryPhoneNumber'?: string;
    /**
     * 
     * @type {MembershipResponse}
     * @memberof UserDetailResponse
     */
    'membership'?: MembershipResponse;
}

export const UserDetailResponseGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE'
} as const;

export type UserDetailResponseGenderEnum = typeof UserDetailResponseGenderEnum[keyof typeof UserDetailResponseGenderEnum];
export const UserDetailResponseDietGoalEnum = {
    LoseWeight: 'LOSE_WEIGHT',
    Maintenance: 'MAINTENANCE',
    GainWeight: 'GAIN_WEIGHT',
    IncreaseMuscles: 'INCREASE_MUSCLES',
    EatHealthy: 'EAT_HEALTHY'
} as const;

export type UserDetailResponseDietGoalEnum = typeof UserDetailResponseDietGoalEnum[keyof typeof UserDetailResponseDietGoalEnum];
export const UserDetailResponseActivityLevelEnum = {
    Sedentary: 'SEDENTARY',
    LightlyActive: 'LIGHTLY_ACTIVE',
    ModeratelyActive: 'MODERATELY_ACTIVE',
    VeryActive: 'VERY_ACTIVE',
    ExtremelyActive: 'EXTREMELY_ACTIVE'
} as const;

export type UserDetailResponseActivityLevelEnum = typeof UserDetailResponseActivityLevelEnum[keyof typeof UserDetailResponseActivityLevelEnum];
export const UserDetailResponseDietTypeEnum = {
    LowCarb: 'LOW_CARB',
    Balanced: 'BALANCED',
    Vegan: 'VEGAN',
    HighProtein: 'HIGH_PROTEIN',
    Keto: 'KETO',
    GlutenFree: 'GLUTEN_FREE'
} as const;

export type UserDetailResponseDietTypeEnum = typeof UserDetailResponseDietTypeEnum[keyof typeof UserDetailResponseDietTypeEnum];


